module.exports = __webpack_public_path__ + "static/hero-recruit-988ec306a56345d81b48d7ed71eaee54.png";